import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import { Backdrop, CircularProgress } from "@mui/material";
import {
  ContentDialog,
  ContentDialogInit,
} from "../MDDForm/components/ContentDialog.jsx";
import { Form, FormRenderer } from "../MDDForm/MDDForm.jsx";
import { useClaimAttachmentActions } from "../../hooks/useClaimAttachmentActions.jsx";

function AttachmentTitleModal({ open, onClose, attachment }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const { updateClaimAttachment } = useClaimAttachmentActions();

  const { openCD, setOpenCD, tca, setTca } = ContentDialogInit();

  useEffect(() => {
    if (!open) {
      setOpenCD(false);
      return;
    }

    const fdef = {
      formdefinition: [
        {
          control: "input",
          name: "bezeichnung",
          label: "Bezeichnung",
          cols: "12",
          valid: "isNotEmpty(item)",
        },
      ],
      transformOut: [],
    };

    setOpenCD(true);
    setTca({
      title: "Bezeichnung bearbeiten",
      maxWidth: "sm",
      content: (
        <Form>
          <FormRenderer
            fdef={fdef}
            model={{
              id: attachment?.id,
              bezeichnung: attachment?.bezeichnung || "",
            }}
            variant="filled"
            editMode={true}
            showActions={true}
            showCancel={true}
            showToggleEdit={false}
            actionsPosition="bottom"
            toggleEditPosition="top"
            showErrorText={false}
            cancelAction={onClose}
            submitAction={{
              method: "callback",
              callback: async (formData) => {
                await updateClaimAttachment(
                  {
                    id: attachment?.id,
                    bezeichnung: formData?.bezeichnung,
                  },
                  {
                    setIsLoading,
                    onSuccess: () => {
                      enqueueSnackbar("Bezeichnung aktualisiert", {
                        variant: "success",
                      });
                      onClose();
                    },
                  }
                );
              },
            }}
          />
        </Form>
      ),
      actions: null,
    });
    // eslint-disable-next-line
  }, [open, attachment?.id]);

  return (
    <>
      <Backdrop
        open={isLoading}
        style={{ zIndex: 1300, flexDirection: "column" }}
      >
        <CircularProgress style={{ marginBottom: 16 }} />
      </Backdrop>
      <ContentDialog
        openCD={openCD}
        setOpenCD={setOpenCD}
        tca={tca}
        onClose={onClose}
      />
    </>
  );
}

AttachmentTitleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  attachment: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    bezeichnung: PropTypes.string,
  }),
};

export default AttachmentTitleModal;
